import React from 'react';
import PropTypes from 'prop-types';
import './SlateCheckbox.css';

var SlateCheckbox = function(props) {
  var checked = props.checked;
  var onChange = props.onChange;
  var label = props.label;
  var description = props.description;
  var disabled = props.disabled;
  var badge = props.badge;

  var containerClass = 'slate-checkbox';
  if (disabled) {
    containerClass = containerClass + ' slate-checkbox--disabled';
  }

  var handleChange = function(e) {
    if (onChange) {
      onChange(e, !checked);
    }
  };

  return (
    <label className={containerClass}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="slate-checkbox-input"
      />
      <span className="slate-checkbox-box">
        <svg className="slate-checkbox-icon" viewBox="0 0 12 10" fill="none">
          <path
            d="M1 5L4.5 8.5L11 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="slate-checkbox-content">
        {label && <span className="slate-checkbox-label">{label}</span>}
        {description && <span className="slate-checkbox-description">{description}</span>}
      </span>
      {badge}
    </label>
  );
};

SlateCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  badge: PropTypes.node,
};

SlateCheckbox.defaultProps = {
  checked: false,
  disabled: false,
};

export default SlateCheckbox;
